import type { paths } from '@luxuryescapes/contract-customer-communication';

import { json_headers, request } from '~/services/common';

import { makeCustomerCommunicationV2URL } from './customerCommunicationRequestUtils';

type EmailDeliveryStatus =
  paths['/api/customer-communication/v2/subscriptions/users/{userId}/status']['get']['responses'][200]['content']['application/json']['result'];

async function requestGetEmailDeliveryStatus(userId: string, brand: string): Promise<EmailDeliveryStatus> {
  if (!userId) {
    throw 'missing userId';
  }
  if (!brand) {
    throw 'missing brand';
  }

  const url = makeCustomerCommunicationV2URL(`/subscriptions/users/${userId}/status?brand=${brand}`);

  return request(url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers: json_headers,
  })
    .then((response) => {
      return response.result;
    })
    .catch((error) => {
      throw JSON.stringify(error, null, 2);
    });
}

export default requestGetEmailDeliveryStatus;
